// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC9RiA2JkongE3cHAqUHhHuvNO4CROy9W4",
  authDomain: "flockoffriends-dbcd1.firebaseapp.com",
  projectId: "flockoffriends-dbcd1",
  storageBucket: "flockoffriends-dbcd1.appspot.com",
  messagingSenderId: "705176309125",
  appId: "1:705176309125:web:78f70b0025035ed36808ec"
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

export default firebase;
